<template>
  <div class="page">
    <div class="search">
      <div style="display: flex; align-items: center;">
        <div>
          <p>搜索选品平台</p>
          <p>关键词、标题搜索</p>
        </div>
        <div style="margin-left: 20px;">
          <el-input
            placeholder="请输入搜索关键字"
            v-model="form.title"
            clearable
            class="input-with-select"
            style="border: 2px solid #ff5d00; border-right: none;"
            @clear="getList"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getList"
              class="search_button"
            >
              搜本市场
            </el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div style="font-size: 20px; color: red;">
      选品前请先确保积分比例已设置并且开启
      <span style="color: #00a4ff; cursor: pointer;" @click="gotoSet">
        去设置
      </span>
    </div>
    <div class="search_condition">
      <div class="categoryList1">
        <div
          v-for="(item, i) in categoryList"
          class="categoryList"
          :style="
            item.id == form.cate_id
              ? { background: '#ff5d00', color: '#fff' }
              : ''
          "
          @click="cate_search(item, i)"
        >
          {{ item.nickname }}
        </div>
      </div>
      <div
        style="
          margin-top: 15px;
          display: flex;
          align-items: center;
          font-size: 15px;
          padding: 0 10px;
        "
      >
        <div>价格区间:</div>
        <el-input
          v-model="form.pricefrom"
          style="width: 150px; margin-right: 10px; margin-left: 10px;"
        >
          <template slot="append">元</template>
        </el-input>
        至
        <el-input
          v-model="form.priceto"
          style="width: 150px; margin-left: 10px;"
        >
          <template slot="append">元</template>
        </el-input>
        <el-button
          icon="el-icon-search"
          style="margin-left: 10px;"
          @click="getList"
        >
          筛 选
        </el-button>
        <div
          v-for="(item, i) in statusList"
          class="categoryList2"
          :style="
            item.id == form.choose
              ? { background: '#ff5d00', color: '#fff' }
              : ''
          "
          @click="status_search(item, i)"
        >
          {{ item.name }}
        </div>
      </div>
      <div style="margin-top: 15px; display: flex;">
        <el-button
          icon="el-icon-check"
          style="margin-left: 10px;"
          @click="All_check"
        >
          全部选品
        </el-button>
        <el-button
          icon="el-icon-close"
          style="margin-left: 10px;"
          @click="All_remove"
        >
          移除全部
        </el-button>
        <el-button
          icon="el-icon-close"
          style="margin-left: 10px;"
          @click="All_remove"
        >
          产品上新
        </el-button>
      </div>
    </div>
    <div
      style="display: flex; flex-wrap: wrap; margin-left: 20px; width: 100%;"
      v-if="goodsList.length > 0"
    >
      <el-card
        :body-style="{ padding: '0px' }"
        style="margin: 0 20px 10px 0; cursor: pointer;"
        v-for="item in goodsList"
        :key="item.id"
        class="card"
      >
        <!--        <el-checkbox style="position: absolute;top: 0;margin-left: 0;" v-model="item.check" @change="checkeds(item,$event)"></el-checkbox>-->
        <div class="neirong">
          <img :src="item.image_url" style="width: 100%; height: 230px;" />
          <div class="zhezhao">
            <el-button
              round
              class="button"
              style="position: absolute; left: 25%; bottom: 20%; z-index: 10;"
              @click="add(item)"
            >
              {{ item.text }}
            </el-button>
          </div>
        </div>
        <div style="padding: 14px; width: 100%;">
          <div class="body-title">{{ item.title }}</div>
          <div class="body-title" style="color: #999; margin-top: 8px;">
            月销：{{ item.sale_num }}件
          </div>
          <div style="margin-top: 10px;">
            <div>
              <div style="font-size: 18px; color: red;">
                <span>¥{{ item.money }}</span>
                <span>或</span>
                <span>{{ item.total_point }}积分</span>
              </div>
              <div
                style="
                  font-size: 16px;
                  color: #999999;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <span style="text-decoration: line-through;">
                  ¥{{ item.price }}
                </span>
                <el-button
                  type="text"
                  v-if="item.status == 1"
                  @click="delts(item)"
                >
                  移除选品
                </el-button>
              </div>
              <div
                style="
                  font-size: 12px;
                  color: #999999;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <span>用户可得:¥{{ item.give_user }}</span>
                <span>商户可得:¥{{ item.give_app }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="[5, 10, 18, 20]"
        :page-size="form.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  category_list,
  check_goods,
  chooseAll,
  integral_goods_list,
  remove_goods,
  removeAll,
} from '@/api/integralMall'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['token', 'app_id']),
  },
  data() {
    return {
      goodsList: [],
      statusList: [
        {
          name: '已选品',
          id: 1,
        },
        {
          name: '未选品',
          id: 2,
        },
      ],
      form: {
        limit: 18,
        page: 1,
        cate_id: '',
        choose: 1,
        priceto: '',
        pricefrom: '',
      },
      total: 0,
      categoryList: [],
      IsShow: false,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    checkeds(it, e) {
      console.log(e)
      if (e) {
      }
      this.$forceUpdate()
    },
    handleSizeChange(e) {
      this.form.limit = e
      this.getList()
    },
    handleCurrentChange(e) {
      this.form.page = e
      this.getList()
    },
    init() {
      this.getcategory_list()
      this.getList()
    },
    gotoSet() {
      sessionStorage.setItem('mychild', '设置积分比例')
      this.$router.push('/apply/newVip/13/xuanpinku/integral_set')
    },
    async All_check() {
      const res = await chooseAll({ app_id: this.app_id })
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.getList()
      }
    },
    async All_remove() {
      const res = await removeAll({ app_id: this.app_id })
      if (res.code == 200) {
        this.$message.success(res.msg)
        this.getList()
      }
    },
    async add(it) {
      if (it.status == 0) {
        const res = await check_goods({ app_id: this.app_id, goods_id: it.id })
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.getList()
        }
      }
    },
    async delts(it) {
      const res = await remove_goods({ app_id: this.app_id, goods_id: it.id })
      if (res.code == 200) {
        this.getList()
      }
    },
    cate_search(it, i) {
      this.form.page = 1
      if (this.form.cate_id == it.id) {
        this.form.cate_id = ''
      } else {
        this.form.cate_id = it.id
      }
      this.getList()
    },
    status_search(it, i) {
      if (this.form.choose == it.id) {
        this.form.choose = ''
      } else {
        this.form.choose = it.id
      }
      this.getList()
    },
    async getList() {
      const res = await integral_goods_list({
        app_id: this.app_id,
        ...this.form,
      })
      if (res.code == 200) {
        this.goodsList = res.data.data
        this.goodsList.forEach((e) => {
          e.text = e.status == 1 ? '已加入选品' : '加入选品'
          e.check = true
        })
        this.total = res.data.total
      }
    },
    async getcategory_list() {
      const res = await category_list({ app_id: this.app_id })
      if (res.code == 200) {
        this.categoryList = res.data
        this.categoryList.unshift({
          id: '',
          nickname: '全部',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.page {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f7f7f7;
  padding: 24px 0;
}
.card {
  width: 15%;
  position: relative;
}
.search {
  width: 100%;
  padding: 20px 0;
  background-color: #ffffff;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
}
p {
  font-size: 16px;
  color: #333;
}
.input-with-select {
  width: 610px;
}
.search_button {
  background-color: #ff5d00 !important;
  color: #ffffff !important;
  font-size: 16px;
  border: 2px solid #ff5d00;
  border-radius: unset;
}
.image {
  width: 100%;
  height: 100%;
}
.body-title {
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}
.search_condition {
  width: 100%;
  padding: 20px 0;
  background-color: #ffffff;
  margin-bottom: 15px;
}
.categoryList1 {
  width: 100%;
  display: flex;
  flex-flow: wrap;
  .categoryList {
    width: 8%;
    font-size: 16px;
    margin-bottom: 10px;
    // height: 35px;
    padding: 5px;
    text-align: center;
    // line-height: 35px;
    cursor: pointer;
    border: 1px #e6e6e6 solid;
    margin-left: 10px;
  }
}
.categoryList2 {
  width: 8%;
  padding: 5px;
  font-size: 16px;
  // margin-bottom: 10px;
  // height: 35px;
  text-align: center;
  // line-height: 35px;
  cursor: pointer;
  border: 1px #e6e6e6 solid;
  margin-left: 10px;
}

.neirong {
  width: 100%;
  /*height: 235px;*/
  position: relative;
}
.neirong .zhezhao {
  position: absolute;
  top: 0;
  width: 100%;
  height: 230px;
  opacity: 0.6;
  background: #999999;
  display: none;
}
.neirong:hover .zhezhao {
  display: block;
}
.block {
  width: 100%;
  background: #ffffff;
  padding: 15px;
  display: flex;
  justify-content: center;
}
.bottom {
  width: 100%;
  padding: 15px 0;
  background: #ffffff;
  position: fixed;
  font-size: 25px;
  bottom: 0;
  display: flex;
  /*justify-content: center;*/
  align-items: center;
}
::v-deep.el-checkbox__inner {
  width: 25px;
  height: 25px;
  border: 2px #000000 solid;
}
::v-deep.el-checkbox__inner::after {
  width: 6px;
  height: 14px;
  top: 0;
  left: 7px;
}
</style>
